// src/index.jsx - Entry point (if needed)
console.log('🔴 index.jsx: Starting to load');

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

console.log('🔴 index.jsx: All imports loaded');
console.log('🔴 React:', React);
console.log('🔴 ReactDOM:', ReactDOM);
console.log('🔴 App:', App);

const rootElement = document.getElementById('root');
console.log('🔴 Root element:', rootElement);

if (!rootElement) {
  console.error('❌ CRITICAL: Root element not found!');
  alert('CRITICAL ERROR: Root element not found in DOM!');
} else {
  try {
    console.log('🔴 Creating React root...');
    const root = ReactDOM.createRoot(rootElement);
    console.log('🔴 React root created, rendering App...');

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );

    console.log('🔴 App render called successfully');
  } catch (error) {
    console.error('❌ CRITICAL ERROR rendering React app:', error);
    console.error('❌ Error stack:', error.stack);
    console.error('❌ Error name:', error.name);
    console.error('❌ Error message:', error.message);

    // Show error to user
    document.body.innerHTML = `
      <div style="padding: 40px; background: #1a1a2e; color: white; font-family: monospace;">
        <h1 style="color: #ff6b6b;">React App Failed to Load</h1>
        <p><strong>Error:</strong> ${error.message}</p>
        <pre style="background: #0f0f23; padding: 20px; overflow: auto;">${error.stack}</pre>
        <p>Please refresh the page or contact support.</p>
      </div>
    `;

    throw error; // Re-throw to ensure it appears in console
  }
}